import { combineReducers } from 'redux'
import commonReducer from './reducers/common-reducer'
import checkOut2Reducer from './reducers/check-out2-reducer'
import flightReducer from "./reducers/flight-reducer";
import comboSearchReducer from "./reducers/home-reducer";

export default combineReducers({
    commonReducer: commonReducer,
    checkOut2Reducer: checkOut2Reducer,
    flightReducer: flightReducer,
    comboSearchReducer: comboSearchReducer,
})
